
interface StepItemProps {
  number: number;
  title: string;
  description: string;
  compact?: boolean;
}

export function StepItem({ number, title, description, compact = false }: StepItemProps) {
  return (
    <div className="flex gap-4 items-center">
      <div className="h-10 w-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">
        {number}
      </div>
      <div>
        <h3 className={`text-xl font-semibold ${compact ? 'text-base' : ''}`}>{title}</h3>
        <p className={`text-muted-foreground ${compact ? 'text-sm' : ''}`}>{description}</p>
      </div>
    </div>
  );
}
